
import Vue from 'vue'

import SecurityPhotoTransformer from '@/transformers/workPlan/securityPhoto'
import errorHandler from '@/utils/errorHandler'

const keysTranslation = {
  photo: 'Foto',
}

const ignoredKeyNames = ['photo']

export default (payload) => {
	const transformed = SecurityPhotoTransformer.send(payload)
	const config = { headers: {'Content-Type': 'multipart/form-data' }}

  const request = Vue.$http.post('workplan/security-photo/', 
                                     transformed, config)
  return errorHandler(request, {keysTranslation, ignoredKeyNames})
		.then(response => SecurityPhotoTransformer.fetch(response.data))
}



// WEBPACK FOOTER //
// ./src/services/workPlan/sendSecurityPhoto.js